import { api, apiErrorHandler, notify } from 'services';
import { call, put } from 'redux-saga/effects';
import {
  FetchAlertEmailLogsActions as Actions,
  FetchAlertEmailLogsRequestAction as RequestAction,
} from 'store/ducks/alertEmailLogs';

export function* fetchAlertEmailLogsRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;

  try {
    const { data } = yield call(api.get, `alert-email-log/${id}`);

    yield put(Actions.success(data));


    onSuccess && onSuccess();
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);

    yield put(Actions.failure(errorMessage));

    onFailure && onFailure();
    notify('error', errorMessage);
  }
}